<template>
	<div class="success-box">
		<div class="wrapper">
			<div class="header">
				<span class="back" @click="back">首页</span>
	        		<p class="title">支付</p>
			</div>
			<div class="content">
				<div class="result-icon"></div>
				<div class="result-box">
					<p class="title" v-if="currentRecharge=='recharge'">支付成功</p>
					<p class="title small" v-if="currentRecharge=='youku'">支付成功，优酷会员将稍后发放到您输入的手机号上，请留意短信。</p>
					<p class="type">订单号：{{type}}</p>
					<p class="money">订单金额：¥{{money}}</p>
					<p class="time">支付时间：{{time}}</p>
					
				</div>
			</div>
			<div class="icon_area">
				<div>
					<!--<span class="look_icon" @click="look"></span>-->
					<span class="back_icon" @click="back"></span>
				</div>
				<p v-if="currentRecharge=='recharge'">预计十分钟内到帐，充值高峰或有延迟</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				type:'',
				time:'',
				money:'',
				currentRecharge:""
			}
		},
		created(){
			this.type = this.getUrlParam("payment_order");
			this.time = this.getUrlParam("payment_success_datetime");
			this.money = this.getUrlParam("amount");
			this.currentRecharge=localStorage.getItem("currentRecharge")
		},
		methods:{
			back(){
				this.$router.push({path:'home'})
			},
			look(){
				this.$router.push({path:'recharge-list'})
			}
		}
	}
</script>

<style scoped="scoped">
	.success-box{
		width: 100%;
		height: 100%;
		background:rgba(245,245,245,1);
	}
	
	.success-box .header{
		padding-top: 0.48rem;
		position: relative;
		width:100%;
		height:0.8rem;
		background:rgba(255,255,255,1);
	}
	.success-box .header .title{
		/*padding-top: 0.48rem;*/
		width:100%;
		height:0.67rem;
		font-size:0.48rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(34,34,34,1);
		line-height:0.67rem;
		text-align: center;
	}
	.success-box .back{
		position: absolute;
		left: 0.3rem;
		padding-left: 0.28rem;
		display: inline-block;
		width:1.2rem;
		height:0.67rem;
		font-size:0.3rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(74,144,226,1);
		line-height:0.67rem;
		background: url(../assets/img/back@2x.png) no-repeat left center;
		background-size: 0.23rem;
	}
	.success-box .content{
		width: 100%;
		height: 5.52rem;
		background: url(../assets/img/success-bg@2x.png) no-repeat;
		background-size: 100% 5.52rem;
	}
	.success-box .content .result-icon{
	    padding: 0.72rem 0 0.3rem;
	    width: 100%;
	    height: 1.75rem;
		background: url(../assets/img/success-icon@2x.png) no-repeat center;
		background-size: 1.75rem;
	}
	.success-box .content .result-box p{
		margin-bottom: 0.12rem;
	}
	.success-box .content .title{
		
		text-align: center;
		font-size:0.48rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(255,255,255,1);
	}
	.success-box .content .type,.success-box .content .money,.success-box .content .time{
		text-align: center;
		font-size:0.3rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(255,255,255,1);
	}
	.icon_area>div{
		display: flex;
		margin: 0.86rem 0;
	}
	.icon_area p{
		text-align: center;
		font-size:0.2rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(74,144,226,1);
	}
	.icon_area span{
		display: inline-block;
		flex: 1;
		/*width: 2.49rem;*/
		height: 0.72rem;
	}
	.icon_area .look_icon{
		background: url(../assets/img/look_icon@2x.png) no-repeat center center;
		background-size: 2.49rem 0.72rem;
	}
	.icon_area .back_icon{
		background: url(../assets/img/back_icon@2x.png) no-repeat center center;
		background-size: 2.49rem 0.72rem;
	}
	.success-box .content  .small{
		font-size:0.3rem !important;
		padding:0 0.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/success.vue